export const PHC_DARK = {
  pageBg: "#000000",
  sectionBg:
    "linear-gradient(336deg, rgba(0,0,0,0.3) 0%, rgba(85,85,85,0.1) 100%)",
  sectionBorder: "#393939",
  textPrimary: "#FFFFFF",
  textSecondary: "rgba(255,255,255,0.72)",
  textMuted: "rgba(255,255,255,0.55)",
  positive: "#00E676",
  negative: "#FF5252",
  cardShadow: "0px 2px 4px -2px rgba(0,0,0,0.1), 0px 4px 6px -1px rgba(0,0,0,0.1)",
  insetGlow: "inset 0px 0px 10px 0px rgba(255,255,255,0.35)",
  sectionInsetGlow: "inset 0px 0px 8px 0px rgba(255,255,255,0.25)",
  radiusSection: "20px",
  radiusCard: "20px",
  titleGradient: "linear-gradient(90deg, #2485FD 0%, #07038D 100%)",
  metaLabelColor: "#A7A7A7",
  subtitleColor: "#C7C7C7",
  cardBg: "rgba(0,0,0,0.55)",
  mobileCardBg: "rgba(23,33,33,0.6)",
  mobileCardBorder: "1px solid rgba(61,218,227,0.1)",
  mobileMetaBorder: "1px solid rgba(255,255,255,0.1)",
  mobileMetaBg: "rgba(255,255,255,0.03)",
  mobileTitleColor: "#0085FF",
  mobileSubtitleColor: "#9CA3AF",
  mobileValueColor: "#DAE5E4",
  mobileLabelColor: "#BBC9CA",
  mobileChipActiveBg: "#0C1E33",
  mobileChipIdleBg: "#172121",
  mobileChipActiveBorder: "#2977EC",
  mobileChipIdleBorder: "#3C494A",
  mobileChipAccent: "#2977EC",
  mobileMetricBorder: "rgba(187,201,202,0.1)",
  dividerColor: "rgba(255,255,255,0.35)",
  badgeBg: "rgba(255,255,255,0.08)",
  snapshotIconShadow: "none",
  snapshotIconBg: null,
  chartGridColor: "rgba(255,255,255,0.12)",
  chartAxisColor: "rgba(255,255,255,0.55)",
  chartTooltipBg: "#1A1A1A",
  chartTooltipText: "#FFFFFF",
  chartTooltipBorder: "#393939",
  chartPlotLineColor: "rgba(255,255,255,0.45)",
  saveBarBg: "rgba(0,0,0,0.55)",
  saveBarBgImage:
    "linear-gradient(-6.18deg, rgba(0, 0, 0, 0.3) 0%, rgba(85, 85, 85, 0.1) 100%)",
  saveBarShadow: "0px -6px 16px -1px rgba(255,255,255,0.16)",
  saveButtonBg:
    "linear-gradient(-25.02deg, rgba(39, 40, 44, 0.5) 0%, rgba(203, 203, 203, 0.25) 100%)",
  saveButtonText: "#F5F5F5",
  termToggleTrack: "#000000",
  termToggleBorder: "1px solid rgba(255,255,255,0.2)",
  termToggleActiveBg: "#FFFFFF",
  termToggleActiveColor: "#0A0A0A",
  termToggleIdleColor: "#FFFFFF",
  innerPanelInsetGlow: "inset 0px 0px 3px 0px rgba(255,255,255,0.25)",
  sectionBorderSoft: "#393939",
  tableHeaderBg: "#1a1a1a",
  tableHeaderBgAlt: "#333333",
  tableHeaderSolid: "rgba(0,126,240,0.2)",
  tableRowBg: "#1B1B1B",
  tableRowBorder: "#333333",
  tableHeaderText: "#D1D5DC",
  tableStickyBorder: "rgba(255,255,255,0.08)",
  innerTableBg: "rgba(31,31,31,0.2)",
  insightBannerBg: "transparent",
  promoCardBg: "#00010D",
  promoFooterBg: "#010D1B",
  promoFooterBgMobile: "#00010D",
  promoFooterBorder: "#3C4D62",
  promoTitleColor: "#FFFFFF",
  linkColor: "#2879D8",
  highlightTones: {
    positive: "#45AC70",
    negative: "#C40000",
    neutral: "#FFFFFF",
  },
  footerTones: {
    success: { bg: "#0F3D2B", color: "#57F09E" },
    warning: { bg: "#4A2F00", color: "#FFBA45" },
    info: { bg: "#0D2A3D", color: "#5DC8FF" },
  },
  remarkStyles: {
    "TOP WINNER": {
      color: "#86EFAC",
      bg: "rgba(21,128,61,0.25)",
      border: "rgba(134,239,172,0.4)",
    },
    WINNER: {
      color: "#86EFAC",
      bg: "rgba(21,128,61,0.25)",
      border: "rgba(134,239,172,0.4)",
    },
    FLAT: {
      color: "#BBC9CA",
      bg: "rgba(120,144,143,0.2)",
      border: "rgba(187,201,202,0.35)",
    },
    LAGGARD: {
      color: "#F6A823",
      bg: "rgba(246,168,35,0.2)",
      border: "rgba(246,168,35,0.4)",
    },
    DRAG: {
      color: "#F87171",
      bg: "rgba(196,0,0,0.25)",
      border: "rgba(248,113,113,0.4)",
    },
    "BIGGEST DRAG": {
      color: "#F87171",
      bg: "rgba(196,0,0,0.4)",
      border: "rgba(248,113,113,0.45)",
    },
    Overweight: {
      color: "#F6A823",
      bg: "rgba(246,168,35,0.2)",
      border: "rgba(246,168,35,0.4)",
    },
    Underweight: {
      color: "#1E88E5",
      bg: "rgba(30,136,229,0.2)",
      border: "rgba(30,136,229,0.4)",
    },
    "Severe Overweight": {
      color: "#F87171",
      bg: "rgba(196,0,0,0.25)",
      border: "rgba(248,113,113,0.4)",
    },
    "Severe Underweight": {
      color: "#1E88E5",
      bg: "rgba(30,136,229,0.2)",
      border: "rgba(30,136,229,0.4)",
    },
    Neutral: {
      color: "#78908F",
      bg: "rgba(120,144,143,0.2)",
      border: "rgba(120,144,143,0.35)",
    },
  },
  actionStyles: {
    TRIM: { color: "#C40000", bg: "rgba(196,0,0,0.2)" },
    HOLD: { color: "#F6A823", bg: "rgba(246,168,35,0.2)" },
    IDEAL: { color: "#45AC70", bg: "rgba(69,172,112,0.2)" },
  },
  vsIdealColors: {
    negative: "#C40000",
    warning: "#F6A823",
    positive: "#45AC70",
    neutral: "#FFFFFF",
  },
  taxValueTones: {
    positive: "#45AC70",
    negative: "#C40000",
    neutral: "#FFFFFF",
  },
  perfTones: {
    positive: "#45AC70",
    negative: "#C40000",
    neutral: "#FFFFFF",
  },
};

export const PHC_LIGHT = {
  pageBg: "#FFFFFF",
  sectionBg: "#FFFFFF",
  sectionBorder: "#393939",
  textPrimary: "#000000",
  textSecondary: "#000000",
  textMuted: "#000000",
  positive: "#00E676",
  negative: "#FF5252",
  cardShadow: "0px 2px 4px -2px rgba(0,0,0,0.1), 0px 4px 6px -1px rgba(0,0,0,0.1)",
  insetGlow: "none",
  sectionInsetGlow: "none",
  radiusSection: "20px",
  radiusCard: "20px",
  titleGradient: "linear-gradient(90deg, #2485FD 0%, #07038D 100%)",
  metaLabelColor: "#000000",
  subtitleColor: "#000000",
  cardBg: "#FFFFFF",
  mobileCardBg: "#FFFFFF",
  mobileCardBorder: "1px solid #E5E7EB",
  mobileMetaBorder: "1px solid #E5E7EB",
  mobileMetaBg: "#FFFFFF",
  mobileTitleColor: "#000000",
  mobileSubtitleColor: "#000000",
  mobileValueColor: "#000000",
  mobileLabelColor: "#6B7280",
  mobileChipActiveBg: "#E8F4FF",
  mobileChipIdleBg: "#F3F4F6",
  mobileChipActiveBorder: "#2977EC",
  mobileChipIdleBorder: "#E5E7EB",
  mobileChipAccent: "#2977EC",
  mobileMetricBorder: "rgba(0,0,0,0.08)",
  dividerColor: "#393939",
  badgeBg: "rgba(0,0,0,0.06)",
  snapshotIconShadow: "0px 0px 2px rgba(0,0,0,0.25)",
  snapshotIconBg: "#FFFFFF",
  chartGridColor: "rgba(0,0,0,0.08)",
  chartAxisColor: "rgba(0,0,0,0.55)",
  chartTooltipBg: "#FFFFFF",
  chartTooltipText: "#000000",
  chartTooltipBorder: "#393939",
  chartPlotLineColor: "rgba(0,0,0,0.2)",
  saveBarBg: "#FFFFFF",
  saveBarBgImage: "none",
  saveBarShadow: "0px -6px 16px -1px rgba(0,0,0,0.08)",
  saveButtonBg: "#007EF0",
  saveButtonText: "#FFFFFF",
  termToggleTrack: "#F3F4F6",
  termToggleBorder: "1px solid #393939",
  termToggleActiveBg: "#FFFFFF",
  termToggleActiveColor: "#0A0A0A",
  termToggleIdleColor: "#6B7280",
  innerPanelInsetGlow: "none",
  sectionBorderSoft: "rgba(0,0,0,0.18)",
  tableHeaderBg: "#007EF0",
  tableHeaderBgAlt: "#007EF0",
  tableHeaderSolid: "#007EF0",
  tableRowBg: "#FFFFFF",
  tableRowBorder: "#393939",
  tableHeaderText: "#FFFFFF",
  tableStickyBorder: "rgba(0,0,0,0.06)",
  innerTableBg: "#FFFFFF",
  insightBannerBg: "#ECECEC",
  promoCardBg: "#00010D",
  promoFooterBg: "#010D1B",
  promoFooterBgMobile: "#00010D",
  promoFooterBorder: "#3C4D62",
  promoTitleColor: "#FFFFFF",
  linkColor: "#2879D8",
  highlightTones: {
    positive: "#000000",
    negative: "#000000",
    neutral: "#000000",
  },
  footerTones: {
    success: { bg: "#00CA7B", color: "#D1FFE6" },
    warning: { bg: "#B67400", color: "#FFBA45" },
    info: { bg: "#0076C3", color: "#B5E6FF" },
  },
  remarkStyles: {
    "TOP WINNER": {
      color: "#000000",
      bg: "rgba(69,172,112,0.2)",
      border: "rgba(69,172,112,0.35)",
    },
    WINNER: {
      color: "#000000",
      bg: "rgba(69,172,112,0.2)",
      border: "rgba(69,172,112,0.35)",
    },
    FLAT: {
      color: "#000000",
      bg: "rgba(120,144,143,0.2)",
      border: "rgba(120,144,143,0.35)",
    },
    LAGGARD: {
      color: "#000000",
      bg: "rgba(246,168,35,0.2)",
      border: "rgba(246,168,35,0.4)",
    },
    DRAG: {
      color: "#000000",
      bg: "rgba(255,127,127,0.4)",
      border: "rgba(255,127,127,0.45)",
    },
    "BIGGEST DRAG": {
      color: "#000000",
      bg: "rgba(255,127,127,0.4)",
      border: "rgba(255,127,127,0.45)",
    },
    Overweight: {
      color: "#000000",
      bg: "rgba(246,168,35,0.2)",
      border: "rgba(246,168,35,0.4)",
    },
    Underweight: {
      color: "#000000",
      bg: "rgba(30,136,229,0.2)",
      border: "rgba(30,136,229,0.4)",
    },
    "Severe Overweight": {
      color: "#000000",
      bg: "rgba(255,127,127,0.4)",
      border: "rgba(255,127,127,0.45)",
    },
    "Severe Underweight": {
      color: "#000000",
      bg: "rgba(30,136,229,0.2)",
      border: "rgba(30,136,229,0.4)",
    },
    Neutral: {
      color: "#000000",
      bg: "rgba(120,144,143,0.2)",
      border: "rgba(120,144,143,0.35)",
    },
  },
  actionStyles: {
    TRIM: { color: "#000000", bg: "rgba(0,0,0,0.04)" },
    HOLD: { color: "#000000", bg: "rgba(246,168,35,0.2)" },
    IDEAL: { color: "#000000", bg: "rgba(69,172,112,0.2)" },
  },
  vsIdealColors: {
    negative: "#000000",
    warning: "#000000",
    positive: "#000000",
    neutral: "#000000",
  },
  taxValueTones: {
    positive: "#45AC70",
    negative: "#C40000",
    neutral: "#000000",
  },
  perfTones: {
    positive: "#45AC70",
    negative: "#C40000",
    neutral: "#000000",
  },
};

export const SNAPSHOT_CARD_THEMES_DARK = {
  invested: {
    topBorder: "#2879D8",
    iconBg: "linear-gradient(135deg, rgba(40,121,216,0.6) 0%, rgba(9,0,13,0.6) 100%)",
    icon: "/images/phc-dashboard/snapshot-rupee.svg",
  },
  current: {
    topBorder: "#13AAD0",
    iconBg:
      "linear-gradient(135deg, rgba(19,170,208,0.6) 18%, rgba(21,12,2,0.6) 100%)",
    icon: "/images/phc-dashboard/snapshot-pie.svg",
  },
  returns: {
    topBorder: "#637CEB",
    iconBg:
      "linear-gradient(135deg, rgba(99,124,235,0.6) 0%, rgba(0,4,22,0.6) 100%)",
    icon: "/images/phc-dashboard/snapshot-percent.svg",
  },
  stocks: {
    topBorder: "#DFB70B",
    iconBg:
      "linear-gradient(135deg, rgba(223,183,11,0.6) 0%, rgba(31,20,1,0.6) 100%)",
    icon: "/images/phc-dashboard/snapshot-trending.svg",
  },
  beta: {
    topBorder: "#584AC1",
    iconBg: "transparent",
    icon: "/images/phc-dashboard/snapshot-beta.svg",
    fullIcon: true,
  },
};

export const SNAPSHOT_CARD_THEMES_LIGHT = {
  invested: {
    topBorder: "#2879D8",
    iconBg: "#FFFFFF",
    icon: "/images/phc-dashboard/snapshot-rupee.svg",
  },
  current: {
    topBorder: "#13AAD0",
    iconBg: "#FFFFFF",
    icon: "/images/phc-dashboard/snapshot-pie.svg",
  },
  returns: {
    topBorder: "#637CEB",
    iconBg: "#FFFFFF",
    icon: "/images/phc-dashboard/snapshot-percent.svg",
  },
  stocks: {
    topBorder: "#DFB70B",
    iconBg: "#FFFFFF",
    icon: "/images/phc-dashboard/snapshot-trending.svg",
  },
  beta: {
    topBorder: "#584AC1",
    iconBg: "transparent",
    icon: "/images/phc-dashboard/snapshot-beta-light.svg",
    fullIcon: true,
  },
};

export const SNAPSHOT_CARD_THEMES = SNAPSHOT_CARD_THEMES_DARK;

export const PHC_THEMES = { light: PHC_LIGHT, dark: PHC_DARK };

export const SNAPSHOT_THEMES = {
  light: SNAPSHOT_CARD_THEMES_LIGHT,
  dark: SNAPSHOT_CARD_THEMES_DARK,
};

export const PHC_THEME_STORAGE_KEY = "phc-dashboard-theme";
export const PHC_DEFAULT_THEME = "light";

export const getPhcGlassCardSx = (mode) => {
  const isLight = mode === "light";
  return {
    backdropFilter: "blur(18px) saturate(160%)",
    WebkitBackdropFilter: "blur(18px) saturate(160%)",
    bgcolor: isLight ? "rgba(255,255,255,0.46)" : "rgba(12,18,28,0.42)",
    border: isLight
      ? "1px solid rgba(255,255,255,0.72)"
      : "1px solid rgba(255,255,255,0.18)",
    boxShadow: isLight
      ? "0 10px 30px rgba(15,23,42,0.10), inset 0 1px 0 rgba(255,255,255,0.85)"
      : "0 10px 30px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.14)",
    borderRadius: "14px",
  };
};
